import './UpdateProfile.scss'
import React from 'react'
import PrimaryButton from '../../prime-react-overrides/button/Button'
import Modal from '../../prime-react-overrides/modal/Modal'
import PrimeInputText from '../../prime-react-overrides/input-text/InputText'
import Dropdown from '../../prime-react-overrides/dropdown/Dropdown'
import Calendar from '../../prime-react-overrides/calendar/Calendar'
import { DEPARTMENTS } from '../../../config/department';
import { titleCase } from "title-case"
import InputMask from '../../prime-react-overrides/input-mask/InputMask'
import { useState } from 'react'
import InputNumber from '../../prime-react-overrides/input-number/InputNumber'
import { useAddUserDetailsMutation, useGetUserDetailsQuery } from '../../../services/attendance-portal/updateUserDetails'
import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { getDate, getMonth, getYear } from 'date-fns'
import { useDispatch } from 'react-redux'
import { setUserCredentials } from '../../../pages/login-page/LoginAuthSlice'
import { countryOptionTemplate, selectedCountryTemplate } from '../../../utilities/country'
import { countriesData } from '../../../config/countries'

const UpdateProfileModal = ({ onShow, onHide }) => {
    const [addUserDetails] = useAddUserDetailsMutation()
    const { data: getUserData, isLoading } = useGetUserDetailsQuery()
    const [departmentState, setDepartmentState] = useState(null)
    const [contactCode, setContactCode] = useState('')
    const [contactNumber, setContactNumber] = useState(null)
    const [firstNameState, setFirstNameState] = useState('')
    const [lastNameState, setLastNameState] = useState('')
    const [employeeIdState, setEmployeeIdState] = useState('JCR')
    const [designationState, setDesignationState] = useState('')
    const [dob, setDob] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        if (!isLoading && getUserData) {
            const { department, firstName, lastName, employeeId, designation, dateOfBirth, phoneNumber } = getUserData
            const { countryCode, number } = phoneNumber
            const { date, month, year } = dateOfBirth
            setDepartmentState(department ?? null)
            setFirstNameState(firstName ?? '')
            setLastNameState(lastName ?? '')
            setEmployeeIdState(employeeId ?? '')
            setDesignationState(designation ?? '')
            if (dateOfBirth.date !== null || dateOfBirth.month !== null || dateOfBirth.year !== null) setDob(new Date(year, month - 1, date))
            if (countryCode && number) {
                setContactNumber(number)
                setContactCode(countryCode.slice(1))
            }
        }
    }, [isLoading, getUserData])


    const handleSubmitAddDetails = async () => {
        if (firstNameState === '' || lastNameState === '' || designationState === '' || contactNumber === null || contactCode === null || departmentState === null) {
            return toast.error("Please fill all the fields marked with a *")
        }
        let _tempDob = {
            date: getDate(dob),
            month: getMonth(dob) + 1,
            year: getYear(dob)
        }
        const userDetailsData = {
            firstName: titleCase(firstNameState.toLowerCase()),
            lastName: titleCase(lastNameState.toLowerCase()),
            designation: designationState,
            department: departmentState,
            phoneNumber: {
                countryCode: `+${contactCode}`,
                number: contactNumber
            },
            employeeId: employeeIdState,
            dateOfBirth: _tempDob
        }
        const {user, message} = await addUserDetails(userDetailsData).unwrap()
        toast.success(message)
        dispatch(setUserCredentials({ user }))
        onHide()
    }


    return (
        <Modal className='UpdateProfileModal' visible={onShow} onHide={onHide} draggable={false} header='Add Details' breakpoints={{ '640px': '100vw' }} style={{ width: '60vw' }}>
            <div className="grid mb-3">
                <div className="col-5">
                    <div className="flex flex-column">
                        <p className='p-0 m-0 text-sm mb-1 font-light'>First Name *</p>
                        <PrimeInputText value={firstNameState} onChange={(e) => setFirstNameState(e.target.value)} />
                    </div>
                </div>
                <div className="col-4">
                    <div className="flex flex-column">
                        <p className='p-0 m-0 text-sm mb-1 font-light'>Last Name *</p>
                        <PrimeInputText value={lastNameState} onChange={(e) => setLastNameState(e.target.value)} />
                    </div>
                </div>
                <div className="col-3">
                    <div className="flex flex-column">
                        <p className='p-0 m-0 text-sm mb-1 font-light'>Employee ID</p>
                        <InputMask id="basic" mask="JCR9999" value={employeeIdState} placeholder="JCR" onChange={(e) => setEmployeeIdState(e.value)}></InputMask>
                    </div>
                </div>
                <div className="col-5">
                    <div className="flex flex-column">
                        <p className='p-0 m-0 text-sm mb-1 font-light'>Department *</p>
                        <Dropdown value={departmentState} options={DEPARTMENTS} onChange={(e) => setDepartmentState(e.value)} />
                    </div>
                </div>
                <div className="col-7">
                    <div className="flex flex-column">
                        <p className='p-0 m-0 text-sm mb-1 font-light'>Designation *</p>
                        <PrimeInputText value={designationState} onChange={(e) => setDesignationState(e.target.value)} />
                    </div>
                </div>
                <div className="col-5">
                    <div className="CalenderClass flex flex-column">
                        <p className='p-0 m-0 text-sm mb-1 font-light'>Date of Birth *</p>
                        <Calendar value={dob} onChange={(e) => setDob(e.value)} showIcon={true} maxDate={new Date()} />
                    </div>
                </div>
                <div className="col-7">
                    <div className="flex flex-column h-full">
                        <p className='p-0 m-0 text-sm mb-1 font-light'>Phone Number *</p>
                        <div className="flex">

                            <Dropdown className='w-4  mr-3' value={contactCode} options={countriesData} onChange={(e) => setContactCode(e.value)} placeholder='Select'
                                valueTemplate={selectedCountryTemplate} filter optionLabel="name" optionValue="dial_code" filterBy='name' itemTemplate={countryOptionTemplate} />

                            <InputNumber className='w-8' disabled={contactCode === '' && true} inputId="withoutgrouping" value={contactNumber} onValueChange={(e) => setContactNumber(e.value)} placeholder='Enter Phone number' useGrouping={false} title="Without country code" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-content-center">
                <PrimaryButton variant='flat' onClick={handleSubmitAddDetails}>Save</PrimaryButton>
            </div>
        </Modal>
    )
}

export default UpdateProfileModal